"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </ul>;
  }
  return <ul className="space-y-3 text-sm text-muted-foreground">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="hover:text-primary transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function CorporateFooter() {
  const currentYear = new Date().getFullYear();
  return <section id="corporate-footer" className="bg-secondary text-secondary-foreground py-16 lg:py-24 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col gap-6">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594097/img/hsinhui_cosmetics_logo.png" alt="HSINHUI COSMETICS PTY LTD" className="h-7 w-auto object-contain" />
            </Link>
            <div className="text-sm text-muted-foreground space-y-1">
              <p className="font-medium text-foreground mb-2">Registered Office</p>
              <p>UNIT 504 21 MORELAND ST&nbsp;</p>
              <p>FOOTSCRAY VIC Australia 3011</p>
              
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-semibold text-foreground tracking-tight">
              Quick Links
            </h3>
            <MenuProvider menu_id="23">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-semibold text-foreground tracking-tight">
              Corporate Compliance
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li data-index={0}>
                <span className="font-medium text-foreground">ACN:</span> 674 430 070
              </li>
              
              <li data-index={2}>
                <span className="font-medium text-foreground">Legal Basis:</span> Corporations Act 2001
              </li>
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-semibold text-foreground tracking-tight">
              Contact Us
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li data-index={0}>
                <Link to="mailto:info@hshcosmetics.com.au" className="hover:text-primary transition-colors duration-200">
                  info@hshcosmetics.com.au
                </Link>
              </li>
              <li data-index={1}>
                <Link to="tel:+61398765432" className="hover:text-primary transition-colors duration-200"></Link>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-12 bg-border/60" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>
            &copy; {currentYear} HSINHUI COSMETICS PTY LTD. All rights reserved.
          </p>
          <p className="font-medium">Liability Limited by Shares</p>
        </div>
      </div>
    </section>;
}